module.exports = __webpack_public_path__ + "media/images/emails-and-contacts-triplet-2-12def75f042a29bfd8963757dc010d5b.svg";